import React, {useEffect, useMemo, useState} from "react";
import { useForm } from "react-hook-form";
import OWASP from "../../../util/owasp";
import CONFIGURACIONES from "../../../util/constants";
import WaveButton from "../WaveButton.jsx";
import { Functions } from "../../../helpers/Functions.jsx";

const GestionDescuentosModal = ({ show, onClose, onSave, showCreate, title, initDataDescuentos }) => {
    const { handleSubmit: handleSubmitModal, register: registerModal, reset: resetModal, getValues: getValuesModal, setValue : setValueModal, formState: { errors: errorsModal } } = useForm({mode: "onChange"});
    const [totalSaldo, setTotalSaldo] = useState(CONFIGURACIONES.INIT.NULL);

    useEffect(() => {
        resetModal();
        if (initDataDescuentos !== CONFIGURACIONES.INIT.NULL) {
            setValueModal('nroCuota', initDataDescuentos.nroCuota);
            setValueModal('cuota', initDataDescuentos.montoCuota);
            // setDetalles(initDataDescuentos.detalles);
        }
    }, [initDataDescuentos]);


    const changeTipoDescuento = (value) => {
        let valueSetear = null;
        let object = CONFIGURACIONES.INIT.TIPOS_DESCUENTO;  
        if (value == object.INTERES) {
            valueSetear = initDataDescuentos.saldoInteres;
        } else if(value == object.COMISION) {
            valueSetear = initDataDescuentos.saldoComision;
        } else if(value == object.MORA) {
            valueSetear = initDataDescuentos.saldoMora;
        }
        setTotalSaldo(valueSetear);
        setValueModal('saldo', valueSetear, {shouldValidate: true});
    };
    
    const saveData = (form) => {  
        let data = {
            tipoDescuento: form.tipoDescuento,
            importe: form.importe,
            saldo: totalSaldo,
            motivo: form.motivo
        }
        onSave(data);
    };

    return (
        <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                <form className="modal-content" action="" onSubmit={handleSubmitModal(saveData)} autoComplete="off">
                    <div className="modal-header">
                        <h5 className="modal-title"> {title}</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="nroCuota" className="control-label col-form-label">N° Cuota <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="nroCuota"
                                        id="nroCuota"
                                        {...registerModal("nroCuota", {
                                            required: OWASP.REQUIRED,
                                            disabled: CONFIGURACIONES.INIT.STATUS_TRUE,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.nroCuota && errorsModal.nroCuota.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="cuota" className="control-label col-form-label">Cuota <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="cuota"
                                        id="cuota"
                                        {...registerModal("cuota", {
                                            required: OWASP.REQUIRED,
                                            disabled: CONFIGURACIONES.INIT.STATUS_TRUE,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.cuota && errorsModal.cuota.message }</small>
                                </div>
                            </div>
                            
                            <div className="col-sm-12 col-md-6">
                                <div className="form-group">
                                    <label htmlFor="tipoDescuento" className="control-label col-form-label">Tipo de Descuento <span className="text-danger">*</span></label>
                                    <select
                                        {...registerModal("tipoDescuento", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                            onChange: (e) => {
                                                changeTipoDescuento(e.target.value);
                                            }
                                        })} className="form-control" id="tipoDescuento"
                                        defaultValue={""}
                                    >
                                        <option value="" disabled>Seleccione</option>
                                        {
                                            CONFIGURACIONES.INIT.LIST.TIPO_DESCUENTOS.map((el, index) => (
                                                <option key={index} value={el.id}>{el.nombre}</option>
                                            ))
                                        }
                                    </select>
                                    <small className="invalid-feedback"> { errorsModal.tipoDescuento && errorsModal.tipoDescuento.message }</small>
                                </div>
                            </div>

                        </div>

                        <div className="row">      
                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="saldo" className="control-label col-form-label">Saldo <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="saldo"
                                        id="saldo"
                                        {...registerModal("saldo", {
                                            required: OWASP.REQUIRED,
                                            disabled: CONFIGURACIONES.INIT.STATUS_TRUE,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.saldo && errorsModal.saldo.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="importe" className="control-label col-form-label">Importe <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="importe"
                                        id="importe"
                                        {...registerModal("importe", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.importe && errorsModal.importe.message }</small>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-12">
                               <div className="form-group">
                                    <label htmlFor="motivo" className="control-label col-form-label">Motivo <span className="text-danger">*</span></label>
                                    <textarea
                                        className="form-control no-resize"
                                        name="motivo"
                                        id="motivo"
                                        rows={2}
                                        {...registerModal("motivo", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    ></textarea>
                                    <small className="invalid-feedback"> { errorsModal.motivo && errorsModal.motivo.message }</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={onClose}>
                            <i className="mdi mdi-arrow-left"></i> Cerrar
                        </WaveButton>
                        {showCreate && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect" onClick={saveData}>
                            <i className="mdi mdi-content-save-settings"></i> Guardar
                        </WaveButton>}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default GestionDescuentosModal;
